<template>
  <MainLayout>
    <!-- Menu Sub Navigation -->
    <MenuSubNavbar />
    <div class="px-6">
      <!-- Menu List -->
      <MenuList
        v-if="!showForm"
        :menu-items="menuItems"
        :loading="loading"
        :error="error"
        :categories="menuStore.categoriesDetailed"
        :selected-category-id="selectedCategoryId"
        :search-query="menuSearchQuery"
        :view-mode="viewMode"
        @add-item="openAddForm"
        @edit-item="openEditForm"
        @delete-item="deleteMenuItem"
        @toggle-availability="toggleAvailability"
        @filter-category="filterByCategory"
        @search-change="setMenuSearchQuery"
        @update:view-mode="viewMode = $event"
      />

      <!-- Menu Item Form -->
      <MenuItemFormContainer
        v-else
        :current-item="currentItem"
        :form-loading="formLoading"
        :form-errors="formErrors"
        @submit="submitForm"
        @cancel="closeForm"
      />

      <!-- Limit Reached Modal -->
      <LimitReachedModal
        :is-open="showLimitModal"
        :message="limitModalData.message"
        :current-usage="limitModalData.currentUsage"
        :max-limit="limitModalData.maxLimit"
        :current-plan="limitModalData.currentPlan"
        limit-type="menu_items"
        @close="showLimitModal = false"
      />
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { useMenuStore } from '@/stores/menu';
import { useMenuManagement } from '@/composables/useMenuManagement';
import MainLayout from '@/components/layout/MainLayout.vue';
import MenuList from '@/components/menu/MenuList.vue';
import MenuItemFormContainer from '@/components/menu/MenuItemFormContainer.vue';
import MenuSubNavbar from '@/components/menu/MenuSubNavbar.vue';
import LimitReachedModal from '@/components/subscription/LimitReachedModal.vue';
import ViewModeToggle from '@/components/common/ViewModeToggle.vue';

const menuStore = useMenuStore();

// View mode state
const viewMode = ref<'list' | 'card'>('card');

// Use the composable for all menu management logic
const {
  menuItems,
  loading,
  error,
  showForm,
  formLoading,
  formErrors,
  currentItem,
  selectedCategoryId,
  menuSearchQuery,
  showLimitModal,
  limitModalData,
  initialize,
  filterByCategory,
  setMenuSearchQuery,
  openAddForm,
  openEditForm,
  closeForm,
  deleteMenuItem,
  toggleAvailability,
  submitForm
} = useMenuManagement();

// Add/remove body class for scrollbar control
onMounted(() => {
  initialize();
  document.body.classList.add('menu-view-active');
});

onUnmounted(() => {
  document.body.classList.remove('menu-view-active');
});
</script>
